import { render, staticRenderFns } from "./FaqTopTable.vue?vue&type=template&id=7ae90e4e&"
import script from "./FaqTopTable.vue?vue&type=script&lang=ts&"
export * from "./FaqTopTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports